<template>
	<div class="measurements-selector__modal" id="modal-share" aria-hidden="true" role="dialog">
		<div class="measurements-selector__modal-overlay"></div>
		<div class="measurements-selector__modal-window" role="document">
			<div class="measurements-selector__modal-header">
				<h2 class="measurements-selector__modal-title">{{ i18n.shareConfiguration }}</h2>
				<a class="measurements-selector__modal-close btn btn--secondary btn--highlight-icon btn--js-modal-close" :aria-label="i18n.closeModal">
					<span class="btn__icon">
						<span class="icon icon-close"></span>
					</span>
				</a>
			</div>
			<div class="measurements-selector__modal-body">
				<div class="measurements-selector__share-generate" v-if="!hasShortLink || hasAlteredConfiguration">
					<span v-if="isGeneratingLink">
						<i class="icon icon-spinner2"></i> {{ i18n.generatingLink }}
					</span>

					<button
						v-else
						class="btn btn--secondary btn--small"
						type="button"
						v-on:click="generateShareableLink()"
						:aria-label="i18n.generateLink"
					>
						<span class="btn__text">
							{{ i18n.generateLink }}
						</span>
					</button>
				</div>
				<div class="measurements-selector__share-link" v-if="hasShortLink && ! hasAlteredConfiguration">
					<input
							class="measurements-selector__share-link-text"
							type="text"
							name="shareableLink"
							:value="shortLink"
							ref="shareableUrl"
							readonly
					/>
					<button
							class="btn btn--secondary btn--copy btn--small"
							type="button"
							v-on:click="copyShareableLink()"
							:aria-label="i18n.copyLink"
					>
						<span class="btn__text">
							{{ i18n.copyLink }}
						</span>
					</button>
				</div>
				<div class="measurements-selector__share-apps" v-if="hasShortLink && ! hasAlteredConfiguration">
					<a
							class="btn btn--secondary btn--highlight-icon btn--share btn--share-whatsapp btn--small"
							:href="whatsappUrl"
							:aria-label="i18n.shareWhatsApp"
							data-action="share/whatsapp/share"
							target="_blank"
					>
						<span class="btn__icon">
							<WhatsApp class="icon-inline icon-inline--expanded svg-icon-whatsapp" aria-hidden="true" />
						</span>
						<span class="btn__text">
							{{ i18n.shareWhatsApp }}
						</span>
					</a>

					<a
							class="btn btn--secondary btn--highlight-icon btn--share btn--small"
							:href="emailUrl"
							:aria-label="i18n.shareMail"
							target="_blank"
					>
						<span class="btn__icon">
							<EmailIcon class="icon-inline icon-inline--expanded svg-icon-email" aria-hidden="true" />
						</span>
						<span class="btn__text">
							{{ i18n.shareMail }}
						</span>
					</a>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
import EmailIcon from "@/components/icons/EmailIcon";
import WhatsApp from "@/components/icons/WhatsApp";
import {mapGetters, mapActions} from "vuex";
import { sprintf } from 'sprintf-js';

export default {
	components: {
		EmailIcon,
		WhatsApp,
	},
	computed: {
		i18n: function() { return this.$i18n; },
		whatsappUrl: function() { return `whatsapp://send?text=${ sprintf( this.i18n.viewMyConfiguration, window.measurementSelectorVariables.shop.name)} ${this.shortLink}`;},
		emailUrl: function() {
			return sprintf(
				`mailto:?subject=%s&body=%s`,
				encodeURIComponent( sprintf( this.i18n.viewMyConfiguration, window.measurementSelectorVariables.shop.name ) ),
				encodeURIComponent( `${this.shortLink}` )
			);
		},
		hasShortLink: function() {
			return this.shortLink !== '' && this.shortLink !== undefined;
		},
		...mapGetters( [
			'isGeneratingLink',
			'shortLink',
			'hasAlteredConfiguration',
		]),
		...mapActions( [
			'createShareableLink',
		] ),
	},
	methods: {
		copyShareableLink: function() {
			const url = this.$refs.shareableUrl;

			url.select();

			document.execCommand( 'copy' );
		},
		generateShareableLink: function() {
			this.$store.dispatch( 'createShareableLink' );
		}
	},
};
</script>
